import getNextConfig from 'next/config'

const serverRuntimeConfig = () => getNextConfig().serverRuntimeConfig

export default serverRuntimeConfig
